var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix), { 'sw-form-column--margin': !_vm.noLabel } ],style:(_vm.labelStyle)},[(!_vm.noLabel)?_c('div',{class:[(_vm.cssPrefix + "__label"),
      'sw-typo-field-label',
      'sw-flexbox__flex-none',
	  { 'sw-form-column--align': _vm.alignRight },
      'sw-flexbox', 'sw-flexbox--center-items' ]},[_vm._t("label")],2):_vm._e(),_vm._v(" "),_c('div',{class:[(_vm.cssPrefix + "__field"),
      'sw-typo-field-value',
      'sw-flexbox__flex',
	  { 'sw-form-column--align': _vm.alignRight },
      'sw-flexbox', 'sw-flexbox--center-items' ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }